<template>
  <el-dialog
    :visible.sync="visible"
    :title="$t('user.assignTenantTitle')"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="40%"
  >
    <el-form
      :model="dataForm"
      :rules="rules"
      ref="dataForm"
      label-position="top"
      class="assgin-tenant-form"
    >
      <el-row class="row-mar-l">
        <el-col>
          <el-form-item prop="userCode" :label="$t('user.userCodeLabel')">
            <el-input
              v-model="dataForm.userCode"
              :disabled="true"
              :placeholder="$t('user.userCodeLabel')"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="row-mar-l">
        <el-col>
          <el-form-item prop="userName" :label="$t('user.userNameLabel')">
            <el-input
              v-model="dataForm.userName"
              :placeholder="$t('user.userNameLabel')"
              :disabled="true"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="row-mar-l">
        <el-col>
          <el-form-item prop="tenantList" :label="$t('user.ownTenantLbael')">
            <el-select
              v-model="dataForm.tenantList"
              v-defaultSelect="[defaultSelect]"
              multiple
              :placeholder="$t('user.tenantPlaceholder')"
            >
              <el-option
                v-for="item in options"
                :key="item.tenantId"
                :label="item.tenantName"
                :value="item.tenantId"
                :disabled="defaultSelect.includes(item.tenantId)"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <template slot="footer">
      <el-button type="button" class="buttonqx" @click="cancelClick">{{
        $t("user.back")
      }}</el-button>
      <el-button
        type="button"
        class="buttomqr el-button--primary"
        @click="dataFormSubmitHandle()"
        >{{ $t("user.save") }}</el-button
      >
    </template>
  </el-dialog>
</template>

<script>
import debounce from "lodash/debounce";
export default {
  directives: {
    defaultSelect: {
      // componentUpdated 带参的指定信息，特别是value，其值就是带参的值
      componentUpdated(el, bindings) {
        const [defaultValues] = bindings.value; //获取设置的不可编辑默认值
        // 将默认值的close图标隐藏掉
        const dealStyle = (tags) => {
          //循环将默认值数量的 close 图标隐藏
          tags.forEach((el, index) => {
            if (
              index <= defaultValues.length - 1 &&
              ![...el.classList].includes("select-tag-close-none")
            ) {
              el.style.display = "none"; // close 图标隐藏掉
            }
          });
        };
        // 隐藏 el-tag__close
        const tags = el.querySelectorAll(".el-tag__close");
        if (tags.length === 0) {
          setTimeout(() => {
            const tagTemp = el.querySelectorAll(".el-tag__close");
            dealStyle(tagTemp);
          });
        } else {
          dealStyle(tags);
        }
      },
    },
  },
  props: {
    defaultSelect: {
      type: [Array],
      default: () => [],
    },
  },
  data() {
    return {
      visible: false,
      dataForm: {
        userId: "",
        userCode: "",
        userName: "",
        tenantList: [],
        supplierUser:false,

      },
      options: [],
      rules: {
        tenantList: [
          {
            required: true,
            message: this.$t("user.tenantPlaceholder"),
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    init(obj) {
      this.visible = true;
      this.getTenantList();
      this.$nextTick(() => {
        this.$refs["dataForm"].resetFields();
        this.dataForm = {
          ...this.dataForm,
          ...obj,
        };
      });
    },
    getTenantList() {
      this.$request.get("/sys/commTenant/selectList").then((res) => {
        this.options = res;
      });
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
      function() {
        this.$refs["dataForm"].validate((valid) => {
          if (!valid) {
            return false;
          }
          this.$request
            .post('/sys/commuser/saveUserTenantRelationship', this.dataForm
            )
            .then((res, total, code, data,msg) => {
              if(code==1){
                this.$message({
                message: this.$t("prompt.success"),
                type: "success",
                duration: 500,
                onClose: () => {
                  this.visible = false;
                  this.$emit("refreshDataList");
                },
              });             
              }else{
                this.$message({
                message: this.$t("prompt.failed"),
                type: "error",
                duration: 500,
                onClose: () => {
                  this.visible = false;
                  this.$emit("refreshDataList");
                },
              });
              } 
            })
            .catch((err) => {
              console.log(err);
            });
        });
      },
      2000,
      { leading: true, trailing: false }
    ),
    cancelClick() {
      this.visible = false;
    },
  },
};
</script>

<style lang="scss" scope>
.el-input-number {
  width: 100% !important;
}
.el-input__inner {
  text-align: left !important;
}
.buttonqx {
  margin: 0px !important;
  width: 50%;
  background-color: #434343;
  color: #fff;
  border: 0px;
  line-height: 25px;
}
.buttonqx:hover {
  background: #535151 !important;
}
.buttomqr {
  margin-left: 0px !important;
  float: left !important;
  width: 50% !important;
  line-height: 23px;
}
.assgin-tenant-form {
  margin-left: 105px;
  .row-mar-l {
    margin-top: 8px;
    margin-bottom: 0px;
  }
}
</style>
